import { Card, Grid2, styled, Typography } from '@mui/material';
import type { FC } from 'react';
import { AvaniLightTheme } from 'theme/schemes/AvaniLightTheme';
import { usePdfPaginationMulti } from '../../content/hooks';

const AvaniStyledCard = styled(Card)(() => ({
  [`& `]: {
    borderRadius: '16px',
    padding: '16px',
    background: AvaniLightTheme.colors.avani.lightTurc,
    display: 'flex'
  },
  [`.MuiTypography-root.MuiTypography-h3 `]: {
    margin: 0,
    lineHeight: 1,
    display: 'block',
    float: 'left'
  }
}));

interface IProps {
  venueName: string;
}

export const AvaniCurrentVisitHeader: FC<IProps> = ({ venueName }) => {
  const { createTrackedRef } = usePdfPaginationMulti();
  const { ref, style } = createTrackedRef();
  return (
    <Grid2
      id="header"
      ref={ref}
      style={style}
      size={{
        xs: 10
      }}
      marginTop={5}
    >
      <AvaniStyledCard
        sx={{
          flexDirection: 'row',
          alignItems: 'center'
        }}
      >
        <Typography
          variant="h3"
          fontSize={24}
          fontWeight={'bold'}
          lineHeight={'36px'}
          sx={{
            color: AvaniLightTheme.colors.avani.teal,
            paddingTop: '12px',
            flexGrow: 1
          }}
        >
          {venueName}
        </Typography>
        <div
          style={{ width: '200px', flexGrow: 0 }}
          dangerouslySetInnerHTML={{
            __html: `
      <?xml version="1.0" encoding="UTF-8"?>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 301.37 126.55">
  <defs>
    <style>
      .cls-1 {
        fill: #00a7a8;
      }

      .cls-1, .cls-2, .cls-3, .cls-4 {
        stroke-width: 0px;
      }

      .cls-5 {
        clip-path: url(#clippath);
      }

      .cls-2 {
        fill: none;
      }

      .cls-3 {
        fill: url(#linear-gradient);
      }

      .cls-4 {
        fill: #005664;
      }
    </style>
    <clipPath id="clippath">
      <path class="cls-2" d="M47.59,24.92c3.92,5.2,8.19,11.23,12.23,17.41h-24.53c4.58-6.94,9.13-13.2,12.3-17.41M43.35,12.65c-3.33,4.17-30.05,38.09-35.17,59.84h11.21c1.32-4.28,3.97-10.47,9.13-19.3h38.03c4.13,7.09,7.52,13.87,9.22,19.3h11.2c-5.14-21.62-31.82-55.64-35.14-59.83l-4.24-5.33-4.25,5.32Z"/>
    </clipPath>
    <linearGradient id="linear-gradient" x1="-276.51" y1="369.22" x2="-275.22" y2="369.22" gradientTransform="translate(-18420.99 -24660.14) rotate(-180) scale(66.9 -66.9)" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#00a6a6"/>
      <stop offset="1" stop-color="#055765"/>
      <stop offset="1" stop-color="#1d1c1a"/>
    </linearGradient>
  </defs>
  <g>
    <g class="cls-5">
      <rect class="cls-3" x="10.46" y="-3.16" width="74.24" height="86.12" transform="translate(2.19 82.28) rotate(-83.03)"/>
    </g>
    <path class="cls-4" d="M87.75,77.13h-10.9c.08.64.14,1.26.14,1.84,0,16.21-13.19,29.4-29.4,29.4s-29.4-13.19-29.4-29.4c0-.5.04-1.12.13-1.84H7.41c-.05.63-.09,1.24-.09,1.84,0,22.2,18.06,40.26,40.25,40.26s40.26-18.06,40.26-40.26c0-.59-.03-1.21-.09-1.84"/>
  </g>
  <g>
    <path class="cls-4" d="M98.83,50.82l14.66-34.2h4.64l14.66,34.2h-6.89l-3.22-7.57h-13.73l-3.22,7.57h-6.89ZM111.44,37.38h8.7l-4.35-10.11-4.35,10.11Z"/>
    <polygon class="cls-4" points="143.15 41.58 149.65 27.12 156.25 27.12 145.35 50.82 140.95 50.82 130.06 27.12 136.65 27.12 143.15 41.58"/>
    <path class="cls-4" d="M180.75,50.82h-6.11v-1.91c-1.96,1.66-4.2,2.39-6.6,2.39-3.52,0-6.84-1.57-8.94-4.01-1.86-2.15-3.03-5.08-3.03-8.31,0-6.99,5.18-12.36,11.63-12.36,2.69,0,5.08.88,6.94,2.39v-1.91h6.11v23.7ZM174.4,35.42c-1.32-1.76-3.42-2.93-5.86-2.93-3.71,0-6.11,3.08-6.11,6.5,0,3.71,2.69,6.45,6.25,6.45,2.4,0,4.5-1.17,5.72-2.93v-7.09Z"/>
    <path class="cls-4" d="M184.71,50.82v-23.7h6.11v1.91c1.81-1.47,4.06-2.39,6.69-2.39,3.27,0,6.26,1.47,8.21,3.81,1.56,1.86,2.44,4.25,2.44,8.31v12.07h-6.35v-12.56c0-2.35-.54-3.57-1.42-4.45-.83-.83-2.1-1.32-3.57-1.32-2.69,0-4.89,1.71-5.77,2.93v15.39h-6.35Z"/>
    <path class="cls-4" d="M214.98,14.66c2.3,0,4.15,1.76,4.15,4.06s-1.86,4.05-4.15,4.05-4.15-1.76-4.15-4.05,1.86-4.06,4.15-4.06M218.16,50.82h-6.35v-23.7h6.35v23.7Z"/>
  </g>
  <g>
    <path class="cls-1" d="M103.13,85.65c1.95,2.15,4.93,3.76,8.06,3.76,2.93,0,4.98-1.81,4.98-4.3,0-4.4-6.35-4.94-10.94-7.62-2.69-1.56-4.84-3.91-4.84-7.77,0-6.11,5.62-9.63,11.29-9.63,3.47,0,6.69.83,9.92,3.22l-3.42,4.89c-1.37-1.27-3.67-2.25-5.91-2.25-2.49,0-5.28,1.07-5.28,3.71,0,5.52,15.78,3.81,15.78,15.34,0,6.06-5.42,10.26-11.58,10.26-4.59,0-8.84-1.91-12.36-5.13l4.3-4.5Z"/>
    <path class="cls-1" d="M137.29,70.6c7.18,0,12.61,5.52,12.61,12.36s-5.42,12.31-12.61,12.31-12.61-5.47-12.61-12.31,5.42-12.36,12.61-12.36M137.29,89.41c3.71,0,6.25-2.88,6.25-6.45s-2.54-6.5-6.25-6.5-6.25,2.93-6.25,6.5,2.54,6.45,6.25,6.45"/>
    <rect class="cls-1" x="153.27" y="60.09" width="6.35" height="34.69"/>
    <path class="cls-1" d="M186.93,71.09v23.7h-6.11v-1.9c-1.86,1.66-4.11,2.39-6.4,2.39-3.27,0-6.21-1.51-8.06-3.81-1.52-1.85-2.4-4.3-2.4-7.82v-12.56h6.35v12.8c0,2.15.44,3.23,1.17,4.06.98,1.08,2.35,1.47,3.57,1.47,2.69,0,4.64-1.81,5.52-2.93v-15.39h6.35Z"/>
    <path class="cls-1" d="M206.6,94.78c-.83.29-2.74.49-3.96.49-3.81,0-6.6-1.27-8.21-3.42-1.22-1.61-1.76-3.71-1.76-7.09v-8.31h-3.11v-5.37h3.11v-4.85l6.35-3.49v8.34h7.82v5.37h-7.82v9.04c0,1.47.24,2.35.78,2.98.63.73,1.66,1.17,3.23,1.17.93,0,2.15-.15,2.59-.24l.98,5.38Z"/>
    <path class="cls-1" d="M214.13,58.63c2.3,0,4.15,1.76,4.15,4.06s-1.86,4.05-4.15,4.05-4.15-1.76-4.15-4.05,1.86-4.06,4.15-4.06M217.3,94.78h-6.35v-23.7h6.35v23.7Z"/>
    <path class="cls-1" d="M233.28,70.6c7.18,0,12.6,5.52,12.6,12.36s-5.42,12.31-12.6,12.31-12.61-5.47-12.61-12.31,5.42-12.36,12.61-12.36M233.28,89.41c3.71,0,6.25-2.88,6.25-6.45s-2.54-6.5-6.25-6.5-6.26,2.93-6.26,6.5,2.54,6.45,6.26,6.45"/>
    <path class="cls-1" d="M249.14,94.91v-23.7h6.11v1.9c1.81-1.47,4.06-2.39,6.69-2.39,3.27,0,6.26,1.47,8.21,3.81,1.56,1.86,2.44,4.25,2.44,8.31v12.07h-6.35v-12.56c0-2.35-.54-3.57-1.42-4.45-.83-.83-2.1-1.32-3.57-1.32-2.69,0-4.89,1.71-5.77,2.93v15.39h-6.35Z"/>
    <path class="cls-1" d="M278.16,87.67c1.61,1.47,4.1,2.35,6.5,2.35,1.71,0,3.03-.83,3.03-2,0-3.57-11.48-2.3-11.48-9.92,0-4.54,4.4-7.38,9.09-7.38,3.08,0,6.45,1.17,8.01,2.39l-2.98,4.6c-1.22-.88-2.83-1.61-4.54-1.61s-3.23.68-3.23,1.91c0,3.08,11.48,1.86,11.48,10.07,0,4.54-4.45,7.33-9.43,7.33-3.27,0-6.74-1.12-9.53-3.18l3.08-4.54Z"/>
  </g>
  <g>
    <path class="cls-1" d="M101.38,111.21v5.38h-2.55v-13.22h4.97c1.7,0,2.7.42,3.44,1.19.66.68,1.04,1.7,1.04,2.74s-.38,2.06-1.04,2.74c-.72.76-1.74,1.17-3.44,1.17h-2.42ZM103.69,108.94c.87,0,1.3-.21,1.61-.53.28-.3.43-.68.43-1.11s-.15-.83-.43-1.13c-.3-.32-.74-.53-1.61-.53h-2.3v3.31h2.3Z"/>
    <path class="cls-1" d="M111.11,102.61c.89,0,1.61.68,1.61,1.57s-.72,1.57-1.61,1.57-1.61-.68-1.61-1.57.72-1.57,1.61-1.57ZM112.34,116.59h-2.46v-9.16h2.46v9.16Z"/>
    <path class="cls-1" d="M114.98,116.59v-9.16h2.36v.74c.7-.57,1.57-.93,2.59-.93,1.27,0,2.42.57,3.17,1.47.6.72.94,1.64.94,3.21v4.66h-2.46v-4.85c0-.91-.21-1.38-.55-1.72-.32-.32-.81-.51-1.38-.51-1.04,0-1.89.66-2.23,1.13v5.95h-2.46Z"/>
    <path class="cls-1" d="M133.02,116.59c-.32.11-1.06.19-1.53.19-1.47,0-2.55-.49-3.17-1.32-.47-.62-.68-1.44-.68-2.74v-3.21h-2.55v-2.08h2.55v-2.55h2.46v2.55h3.02v2.08h-3.02v3.49c0,.57.09.91.3,1.15.25.28.64.45,1.25.45.36,0,.83-.06,1-.09l.38,2.08Z"/>
    <path class="cls-1" d="M135.57,113.79c.62.57,1.59.91,2.51.91.66,0,1.17-.32,1.17-.77,0-1.38-4.44-.89-4.44-3.83,0-1.76,1.7-2.85,3.51-2.85,1.19,0,2.49.45,3.1.93l-1.15,1.77c-.47-.34-1.1-.62-1.76-.62s-1.25.26-1.25.74c0,1.19,4.44.72,4.44,3.89,0,1.76-1.72,2.83-3.64,2.83-1.27,0-2.61-.43-3.68-1.23l1.19-1.76Z"/>
    <path class="cls-1" d="M148.98,113.79c.62.57,1.59.91,2.51.91.66,0,1.17-.32,1.17-.77,0-1.38-4.44-.89-4.44-3.83,0-1.76,1.7-2.85,3.51-2.85,1.19,0,2.49.45,3.1.93l-1.15,1.77c-.47-.34-1.1-.62-1.76-.62s-1.25.26-1.25.74c0,1.19,4.44.72,4.44,3.89,0,1.76-1.72,2.83-3.65,2.83-1.27,0-2.61-.43-3.68-1.23l1.19-1.76Z"/>
    <path class="cls-1" d="M164.99,115.14c-.89,1.06-2.34,1.64-3.76,1.64-2.74,0-4.8-1.89-4.8-4.76,0-2.55,1.74-4.78,4.46-4.78,2.53,0,4.33,2.13,4.33,4.68,0,.25-.02.49-.06.7h-6.35c.13,1.28,1.17,2.17,2.47,2.17,1.04,0,1.87-.58,2.3-1.06l1.4,1.4ZM162.71,110.83c-.08-.81-.81-1.61-1.81-1.61s-1.85.77-1.96,1.61h3.78Z"/>
    <path class="cls-1" d="M173.82,116.59c-.32.11-1.06.19-1.53.19-1.47,0-2.55-.49-3.17-1.32-.47-.62-.68-1.44-.68-2.74v-3.21h-2.55v-2.08h2.55v-2.55h2.46v2.55h3.02v2.08h-3.02v3.49c0,.57.09.91.3,1.15.25.28.64.45,1.25.45.36,0,.83-.06,1-.09l.38,2.08Z"/>
    <path class="cls-1" d="M182.47,116.59c-.32.11-1.06.19-1.53.19-1.47,0-2.45-.49-3.07-1.32-.47-.62-.68-1.44-.68-2.74v-3.21h-2.55v-2.08h2.55v-2.55h2.46v2.55h3.02v2.08h-3.02v3.49c0,.57.09.91.3,1.15.25.28.64.45,1.25.45.36,0,.83-.06,1-.09l.27,2.08Z"/>
    <path class="cls-1" d="M187.19,116.59h-2.46l.1-13.41h2.46l-.1,13.41Z"/>
    <path class="cls-1" d="M197.74,115.14c-.89,1.06-2.45,1.64-3.86,1.64-2.74,0-4.69-1.89-4.69-4.76,0-2.55,1.74-4.78,4.46-4.78,2.53,0,4.33,2.13,4.33,4.68,0,.25-.02.49-.06.7h-6.35c.13,1.28,1.17,2.17,2.47,2.17,1.04,0,1.87-.58,2.3-1.06l1.4,1.4ZM195.45,110.83c-.08-.81-.81-1.61-1.81-1.61s-1.85.77-1.96,1.61h3.78Z"/>
    <path class="cls-1" d="M202.16,113.47c.92,0,1.66.74,1.66,1.66s-.84,1.64-1.77,1.64-1.54-.72-1.54-1.64.72-1.66,1.64-1.66Z"/>
    <path class="cls-1" d="M209.11,103.37h2.57l2.74,8.25,2.91-8.25h1.79l2.91,8.25,2.74-8.25h2.57l-4.48,13.22h-1.79l-2.84-8.37-3.03,8.37h-1.79l-4.28-13.22Z"/>
    <path class="cls-1" d="M235.88,115.14c-.89,1.06-2.34,1.64-3.76,1.64-2.74,0-4.69-1.89-4.69-4.76,0-2.55,1.74-4.78,4.46-4.78,2.53,0,4.22,2.13,4.22,4.68,0,.25-.02.49-.06.7h-6.24c.13,1.28,1.17,2.17,2.47,2.17,1.04,0,1.77-.58,2.2-1.06l1.4,1.4ZM233.59,110.83c-.08-.81-.71-1.61-1.71-1.61s-1.85.77-1.96,1.61h3.67Z"/>
    <path class="cls-1" d="M249.33,116.59v-.74c-.76.64-1.62.93-2.55.93-1.36,0-2.64-.6-3.46-1.55-.72-.83-1.17-1.96-1.17-3.21,0-2.7,2-4.78,4.49-4.78,1,0,1.87.28,2.59.85v-4.91h2.46v13.41h-2.36ZM249.23,110.64c-.51-.68-1.32-1.13-2.27-1.13-1.43,0-2.36,1.19-2.36,2.51,0,1.44,1.04,2.49,2.42,2.49.93,0,1.74-.45,2.21-1.13v-2.74Z"/>
    <path class="cls-1" d="M258.45,107.24c2.78,0,4.87,2.13,4.87,4.78s-2.1,4.76-4.87,4.76-4.87-2.12-4.87-4.76,2.1-4.78,4.87-4.78ZM258.45,114.51c1.44,0,2.42-1.11,2.42-2.49s-.98-2.51-2.42-2.51-2.42,1.13-2.42,2.51.98,2.49,2.42,2.49Z"/>
    <path class="cls-1" d="M265.21,116.59v-9.16h2.36v.74c.7-.57,1.57-.93,2.59-.93,1.27,0,2.42.57,3.17,1.47.6.72.94,1.64.94,3.21v4.66h-2.46v-4.85c0-.91-.21-1.38-.55-1.72-.32-.32-.81-.51-1.38-.51-1.04,0-1.89.66-2.23,1.13v5.95h-2.46Z"/>
    <path class="cls-1" d="M279.44,103.37l-2.27,5.57h-1.79l1.42-5.57h2.64Z"/>
    <path class="cls-1" d="M287.81,116.59c-.32.11-1.06.19-1.53.19-1.47,0-2.55-.49-3.17-1.32-.47-.62-.68-1.44-.68-2.74v-3.21h-2.55v-2.08h2.55v-2.55h2.46v2.55h3.02v2.08h-3.02v3.49c0,.57.09.91.3,1.15.25.28.64.45,1.25.45.36,0,.83-.06,1-.09l.38,2.08Z"/>
    <path class="cls-1" d="M292.38,113.47c.92,0,1.66.74,1.66,1.66s-.74,1.64-1.66,1.64-1.64-.72-1.64-1.64.72-1.66,1.64-1.66Z"/>
  </g>
</svg>
    `
          }}
        />
      </AvaniStyledCard>
    </Grid2>
  );
};
